import * as d3 from '../../vendors/d3/d3.min.js';
import * as moment from 'moment';
import * as _ from 'underscore';
import {environment} from '../../../environments/environment';
import {Action} from '../../model/action';
import {TimeZoneService} from '../../service/TimeZoneService';
import { JustificationMapper } from './justificationMapper.js';
import {
  DATE_D_M_Y_SLASH_FORMAT,
  DATE_TIME_FORMAT,
  MAURICE_TIME_LIMIT
} from '../../model/commons/DateConstants';
import {BlockTempsComponent} from "../../view/block-temps/block-temps.component";
import {MatDatepicker} from "@angular/material";
import {TadInHoursVO} from '../../model/tadInHoursVO';
let originData = {};
let dataBreaks = [];
const maxHours = 10; // maxHours use in checking interval legend of timesheet
const FULLFILLED_PAUSE = 'FULLFILLED_PAUSE';
const PAUSE_INSERVICE = 'PAUSE_INSERVICE';
const STATUS_MOTIF_MOD = "Modulation NAO";
const AllowedToDialog = [
  'INCOHERENCE_CREATED_INSERVICE',
  'INCOHERENCE_CREATED_OFFSERVICE',
  /*  'INCOHERENCE_CREATED_INSERVICE_BYUSER',
    'INCOHERENCE_CREATED_OFFSERVICE_BYUSER',*/
  'INCOHERENCE_VALIDATED_INSERVICE',
  'INCOHERENCE_VALIDATED_OFFSERVICE',
  'INCOHERENCE_CREATED_FORMATIONCONTINUE',
  'INCOHERENCE_VALIDATED_FORMATIONCONTINUE',
  /* 'INCOHERENCE_CREATED_CONTROLEQUALITE',
   'INCOHERENCE_VALIDATED_CONTROLEQUALITE',
   /*  'INCOHERENCE_VALIDATED_INSERVICE_BYUSER',
     'INCOHERENCE_VALIDATED_OFFSERVICE_BYUSER'*/
];
const MIN_BLOCK_LENGTH_FR : number = 60;
export function calcInterval(dates: any, override?: boolean) {
  let hours = 0;
  let dates_in_blocks = dates.temps_data.map(e => { return [e.start, e.end];}) // get all start & end to [[date1, date2]]
    .reduce((p, c) => p.concat(c), []) // concat all array into array to [date1, date2, ....]
    .filter(e => e) // remove case undefined from array
    .map(e => { if (!(e instanceof Date)) e = new Date(e); return e; }); // convert string date to Class Date

  let dates_interval = dates.dataset.map(e => { return e.data.map(c => { return [c[0], c[2]] })}) // get all start & end to [ [ [date1, date2] ]]
    .reduce((p, c) => p.concat(c), []) // get to [[date1, date2], [...]]
    .reduce((p, c) => p.concat(c), []) // concat all array into array to [date1, date2, ....]
    .filter(e => e) // remove case undefined from array
    .map(e => { if (!(e instanceof Date)) e = new Date(e); return e; }) // convert string date to Class Date
    .filter(e => e instanceof Date); // filter has element is type date

  if(dates_interval.length > 0) {
    const startTime = dates_interval.reduce(function (a, b) { return a < b ? a : b; });
    const end = dates_interval.reduce(function (a, b) { return a > b ? a : b; });
    const duration = moment.duration(moment(end).diff(moment(startTime)));
    hours = Math.round(duration.asHours());
  }
  if(dates_in_blocks.length > 0 && hours == 0) {
    const startTime = dates_in_blocks.reduce(function (a, b) { return a < b ? a : b; });
    const end = dates_in_blocks.reduce(function (a, b) { return a > b ? a : b; });
    const duration = moment.duration(moment(end).diff(moment(startTime)));
    hours = Math.round(duration.asHours());
  }
  return override ? override : hours > maxHours ? 3 : 1;
}
export function visavailChart(config: {
  selector: string;
  countryCode: string;
  data: any;
  component: BlockTempsComponent;
  picker: MatDatepicker<Date>;
  message: {icon: string; title: string; body: any; show: boolean};
  extras?: {BLOCK_DATE_FORMAT?: string;};
  translations: {lang: string; translate: any},
  [key: string]: any;
  allTadHours: TadInHoursVO[]
}): any {
  let {selector,countryCode, data: optionData, component: thiscomponent , picker, message, translations, extras,allTadHours} = config;
  let {lang, translate} = translations;


  console.log("allTad : ",allTadHours);
  let date :any = moment(optionData.user.date).format('YYYY-MM-DD');
  if (optionData && optionData.user && optionData.temps_data.length>0){
    allTadHours = allTadHours.filter(t=> t.date == date);
  }else allTadHours = [];

  if (allTadHours && allTadHours.length > 0){
    allTadHours.forEach(t=> {
      if (!t.startTime.includes("-")){
        t.startTime = moment(`${date} ${t.startTime}`).format(DATE_TIME_FORMAT);
        t.endTime = moment(`${date} ${t.endTime}`).format(DATE_TIME_FORMAT);
      }
    });
  }

  /* Tz */
//  console.log(tz.getTimeZoneByUser())

  /* Claim */
  thiscomponent.calimActive = optionData.Display.buttons.claim && thiscomponent.isCurrentUser();

  originData = thiscomponent.blockservice.saveData;
  /* Config*/
  const rmkeys = optionData.dataset.filter( e => optionData.Display.row.indexOf(e.caption) == -1 )
  if (rmkeys.length > 0 ) {
    const _dataset = [];
    optionData.dataset.forEach((e ,i ) => {
      if (rmkeys.indexOf(e) === -1 ) {
        _dataset.push(e);
      }
    })
    if (_dataset.length !== 0)
    {
      optionData.dataset = _dataset;
    }
  }

  // component @injection
  const debug = environment.debug;
  let motifGlobalCode = null;
  let component = null;
  let _dialog = null;
  let current_date = optionData.user.date;
  const events  = null;
  // interval_s
  let interval_s = calcInterval(optionData, optionData.stepHours);
  // legend @injection
  let DataLegend = [];
  // function call Pagination day
  let leftDay;
  let rightDay;
  let TimezoneGMT = thiscomponent.blockservice.tzService.tz;
  // define chart layout
  const margin = optionData.Display.styles.margin;

  // height of horizontal data bars
  const dataHeight = 15;

  // spacing between horizontal data bars
  const lineSpacing = 14;

  // vertical space for heading
  const paddingTopHeading = -50;

  // vertical overhang of vertical grid lines on bottom
  const paddingBottom = 10;

  // space for y axis titles
  const paddingLeft = -100;

  let width = w(document.querySelector(selector).parentNode) - margin.left - margin.right;

  // title of chart is drawn or not (default: yes)
  let drawTitle = 0;

  // year ticks to be emphasized or not (default: yes)
  let emphasizeYearTicks = 1;

  // define chart pagination
  // max. no. of datasets that is displayed, 0: all (default: all)
  let maxDisplayDatasets = 0;

  // dataset that is displayed first in the current
  // display, chart will show datasets "curDisplayFirstDataset" to
  // "curDisplayFirstDataset+maxDisplayDatasets"
  let curDisplayFirstDataset = 0;


  // tooltip of split
  let divSplit;

  // check has active drag & drop
  let enableDrag = false;


  // call init function
  optionData.event && optionData.event.init && optionData.event.init.bind(this).call(this, ...(arguments as any));

  // rm block-info
  d3.select('.block-info').remove();
  function w(element) {
    var style = element.currentStyle || window.getComputedStyle(element),
      width = element.offsetWidth, // or use style.width
      margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight),
      padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight),
      border = parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);

    return width + margin - padding + border
  }

  function openDialogJustifyIncoBreaks(d) {
    if(thiscomponent._isNow || thiscomponent._enableVerro){
      return;
    }
    localStorage.setItem('divBlock', '0')
    localStorage.setItem('usernameEdit', thiscomponent.newuser)
    //this.ContextMenuToggle = false;
    const id = thiscomponent.newuser;
    const temps = [];
    let unlocked = false;
    if (thiscomponent.blockservice.block.isNight) {
      const dateBefore_1 = moment(originData[id].date).format('YYYY-MM-DD');
      const dateAfter_1   = moment(originData[id].date).add(1, 'days').format('YYYY-MM-DD');
      if (!optionData.user.username.startsWith('R')) {
        originData[id].data = thiscomponent.blockservice.filterBlockInIntervall(originData[id].data, dateBefore_1 + ' 12:00:00',  dateAfter_1 + ' 12:00:00');
      } else {
        originData[id].data = thiscomponent.blockservice.filterBlockInIntervall(originData[id].data, dateBefore_1 + MAURICE_TIME_LIMIT,  dateAfter_1 + MAURICE_TIME_LIMIT);
      }
    }
    const planned = [];
    originData[id].data.forEach((e, k) => {

      // check has planned

      if(e.type == "PLANNED") { planned.push(e) }


      const checkMotif = (e.motif !== undefined ? ['SEUILMOINS', 'SEUILPLUS'].indexOf(e.motif.code) === -1 : true);
      if (['FULFILLED_INCOHERENCE'].indexOf(e.name) > -1  && e.activityType.toLowerCase() !== 'unknown'
        && checkMotif && e.validatedBy == null) {
        if (e.GMT === undefined) {
          e.start = e.start;
          e.end = e.end;
          e.GMT = thiscomponent.blockservice.tzService.tz;
        }
        if(temps.map(e => e.id).indexOf(e.id) == -1) {
          temps.push(e);
        }
        // add overflows breaks
        if ( originData[id].breaks.length > 0) {
          originData[id].breaks.forEach((r, i) => {
            if ( temps.map(x => x.id).indexOf(r.id) == -1) {
              if (r.duration > environment.breaks.DURATION.value) {
                temps.push(r)
              }
            }
          });
        }
        if (e.locked.toLowerCase() === 'unlocked') {
          unlocked = true;
        }
      }
    });
    component.closeAll();
    const [p] = planned;
    let ids = [];
    if(p) {
      ids = temps.filter((e) => {
        return (e.start < p.start || e.end < p.start)
      }).map(e => e.id)
    }
    if ((AllowedToDialog.indexOf(d[1]) > -1 && ['SEUILMOINS', 'SEUILPLUS'].indexOf(motifGlobalCode) === -1 && unlocked)) {
      if (thiscomponent.isCurrentUser() && optionData.Display.dialog) {
        component.open(_dialog, {
          panelClass: 'app-dialog',
          data: {
            that: component,
            temps: temps,
            isFormation: thiscomponent._isFormation,
            user: optionData.user,
            addMotifTo: ids
          }
        });
      }
    }
  }


  // global div for tooltip
  const div = d3.select('body').append('div')
    .attr('class', 'tooltip')
    .style('opacity', 0);

  let tooltipResize;
  if(optionData.view == 'ONLY_DATA') {
    d3.select('.toolsplit').remove()
    tooltipResize= d3.select('body').append('div')
      .attr('class', 'toolsplit')
      .style('opacity', 0);
  }
  /* Format Date to GMT */
  /* function GMTToLocale(value, action) {
     const d    = new Date();
     const diff = TimezoneGMT = (d.getTimezoneOffset() / 60) * -1;
     let date = moment(value).add(action * diff, 'hours').toDate();
     if(optionData.user.username[0].toLowerCase() == 'r') {
       date = moment(value).add(0, 'hours').toDate();
       TimezoneGMT = thiscomponent.tzServi;
     }
     return date;
   }*/
  function chart(selection): any {
//      optionData.dataset.
    selection.each(function drawGraph(dataset) {
      // check which subset of datasets have to be displayed
      let maxPages = 0;
      let startSet;
      let endSet;
      if (maxDisplayDatasets !== 0) {
        startSet = curDisplayFirstDataset;
        if (curDisplayFirstDataset + maxDisplayDatasets > dataset.length) {
          endSet = dataset.length;
        } else {
          endSet = curDisplayFirstDataset + maxDisplayDatasets;
        }
        maxPages = Math.ceil(dataset.length / maxDisplayDatasets);
      } else {
        startSet = 0;
        endSet = dataset.length;
      }

      // append data attribute in HTML for pagination interface
      selection.attr('data-max-pages', maxPages);

      const noOfDatasets = endSet - startSet;
      const height = dataHeight * noOfDatasets + lineSpacing * noOfDatasets - 1;

      // parse data text strings to JavaScript date stamps
      const parseDate = d3.time.format('%Y-%m-%d %H:%M:%S');
      dataset.forEach(function (d) {
        d.data.forEach(function (d1) {
          let block: any = {exceptionalTypeLabel: null};
          if(d1["__data__"]) block = d1['__data__'];

          // Get Data Legend Status
          if (DataLegend.indexOf(d1[1]) === -1 && ((d1.__data__ && !d1.__data__.isSeuilFR) || !d1.__data__)) {
            DataLegend.push({exceptionalTypeLabel: block.exceptionalTypeLabel, label: d1[1]});
          }
          if (!(d1[0] instanceof Date)) {
            d1[0] = parseDate.parse(d1[0])
            d1[2] = d3.time.second.offset(d1[0], 0)
          }
        });
      });
      // cluster data by dates to form time blocks
      dataset.forEach(function (series, seriesI) {
        const tmpData = [];
        const dataLength = series.data.length;
        const Starts =  optionData.temps_data;
        series.data.forEach(function (d, i) {
          // if (['PAIDHOLIDAY_OFFSERVICE', 'UNPAIDHOLIDAY_OFFSERVICE', 'EXCEPTIONALHOLIDAY_OFFSERVICE'].indexOf(d[1]) > -1) {
          //   interval_s = 23;
          // }
          if (i !== 0 && i < dataLength) {

            if (true) {
              tmpData[tmpData.length - 1][2] = d[0]; // extend last block until new block starts
              d[3] = 1;
              tmpData[tmpData.length - 1][3] = 1;
              tmpData.push(d);
            }
          } else if (i === 0) {
            d[3] = 0;
            tmpData.push(d);
          }
        });
        /*         for (let i = 0 ; i < tmpData.length - 1 ; i ++ ) {
                   tmpData[i][0] = GMTToLocale(tmpData[i][0], 1);
                   tmpData[i][2] = GMTToLocale(tmpData[i][2], 1);
                 }*/
        const arrayNew = [];
        const r = 0;
        for (let i = 0 ; i < tmpData.length - 1 ; i += 2 ) {
          const start = tmpData[ i ][1];
          const end = tmpData[ i + 1 ][1];
          arrayNew.push(tmpData[ i ]);
          if (start === end) {
            arrayNew.push([tmpData[ i ][0], 'UNKNOWN', tmpData[ i ][0], 'UNKNOWN']);
          }
        }
        if (arrayNew[arrayNew.length - 1] && arrayNew[arrayNew.length - 1][1] === 'UNKNOWN') {
          arrayNew.splice(arrayNew.length - 1, 1);
        }
        dataset[seriesI].disp_data = arrayNew;
      });

      // determine start and end dates among all nested datasets
      let startDate;
      let endDate;

      dataset.forEach(function (series, seriesI) {
        if (seriesI === 0) {
          /*           startDate = GMTToLocale(series.disp_data[0][0], -1)//series.disp_data[0][0];
                     endDate = GMTToLocale(series.disp_data[series.disp_data.length - 1][2], -1);*/
          startDate = series.disp_data[0] && series.disp_data[0][0];
          endDate = series.disp_data[series.disp_data.length - 1] && series.disp_data[series.disp_data.length - 1][2];
        } else {
          if (series.disp_data[0] && series.disp_data[0][0] < startDate) {
            startDate = series.data[0][0], -1;
          }
          if (series.disp_data[series.disp_data.length - 1] && series.disp_data[series.disp_data.length - 1][2] > endDate) {
            endDate = series.disp_data[series.disp_data.length - 1] && series.disp_data[series.disp_data.length - 1][2];
          }
        }
      });

      if(!startDate && !endDate) {
        const dates = dataset.map(e => e.data.map(e => e[0]).flat()).flat();
        startDate=new Date(Math.min.apply(null,dates));
        endDate=new Date(Math.max.apply(null,dates));
      }

      /*      var s = prompt("start");
            var e = prompt("end");
            if(s && e) {
              startDate = moment(s).toDate()
              endDate = moment(e).toDate();
            }*/
      /**
       *  Split Blocks
       *  **/
      divSplit = d3.select('body').append('div')
        .attr('class', 'tooltip-split')
        .style('opacity', 0);
      let resize = () => {};
      if (optionData.enableResize) {
        //if (true) {
        resize = d3.behavior.drag()
          .on('drag', function (c) {
            tooltipResize.style('opacity', 1);
            const elementRect = this.getBoundingClientRect();
            const matrix = this.getScreenCTM().translate(+this.getAttribute('x'), +this.getAttribute('y'));

            optionData.event && optionData.event.drag.bind(this)(c, {
              openDialogJustifyIncoBreaks, optionData, originData, div: divSplit,
              tooltip: tooltipSplit, parseDate,
              event: {saveNewSplit, cancelSplit}
            })

            tooltipResize.html(function (d) {
              return moment(c[2]).format("DD/MM HH:mm");
            })
              .style('left', function () {
                return ((window.pageXOffset + matrix.e + elementRect.width)) + 'px';
              })
              .style('top', function () {
                return ((window.pageYOffset + matrix.f) - 16) + 'px';
              })

          })
          .on("dragend", function (c) {
            if (this.data) {
              const id = this.data.date_[this.data.date_.length - 1];
              let date = [];
              date.push([this.data.date[0], this.data.date_[2], id]);
              if ((this.data.date_[2] && this.data.date[1]) && this.data.date_[2].getTime() < this.data.date[1].getTime()) {
                date.push([this.data.date_[2], this.data.date[1], id]);
              }
              this.data.blocks = date;

              var mapNewLine = JSON.parse(JSON.stringify(new Array(3).fill(this.data.date_)))
              if(date.length > 1) {

                // set block 1
                mapNewLine[0][0] = new Date(date[0][0]);
                mapNewLine[0][2] = new Date(date[0][1]);

                // set block 2 empty
                mapNewLine[1][0] = new Date(date[0][1]);
                mapNewLine[1][1] = "EMPTY";
                mapNewLine[1][2] = new Date(date[1][0]);
                mapNewLine[1][6] = (Math.floor(Math.random() * 10) + (+new Date()));


                // set block 3
                mapNewLine[2][0] = new Date(date[1][0]);
                mapNewLine[2][2] = new Date(date[1][1]);
                mapNewLine[2][6] = (Math.floor(Math.random() * 10) + (+new Date()));
              }


              optionData.event && optionData.event.dragend.bind(this)({id, date, tooltip: divSplit, line: this.data.date_, mapNewLine})
            }
            tooltipResize.transition()
              .duration(500)
              .style('opacity', 0);
          });
      }
      // define scales
      const xScale = d3.time
        .scale()
        .domain([startDate, endDate])
        .range([0, width])
        .clamp(1);

      // define axes
      const xAxis = d3.svg.axis()
        .scale(xScale)
        .orient('top')
        .ticks(d3.time.hours, interval_s)
        .tickFormat(d3.time.format('%H:%S'));

      const zoomWidth = Math.round((width / 12) + 10);
      // create SVG element
      const svgp = d3.select(selector).append('svg')
        .attr('width', "100%")
        .attr('height', optionData.Display.styles.height)
        .attr('id', 'graph_' + optionData.user.username)
        .attr('transform', 'translate(0, 10)')

      const  svg = svgp.append('g')
        .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

      // create basic element groups
      if(optionData.view == 'FULL') {
        svg.append('g').attr('id', 'g_title');
        svg.append('g').attr('id', 'g_breaks');
        svg.append('g').attr('id', 'g_datepicker');
        svg.append('pattern')
          .attr('id', 'grad1')
          .attr('width',8)
          .attr('height',10)
          .attr('patternUnits','userSpaceOnUse')
          .attr('class','XXXXXXXXXXXXXXXXXXXXXXxx')
          .attr('patternTransform','rotate(45 50 50)');
      }
      svg.append('g').attr('id', 'g_axis');
      svg.append('g').attr('id', 'g_data');

      svg.select('#grad1').selectAll('line.vert_grid')
        .data(["data"])
        .enter()
        .append('line')
        .attr('stroke','#a6a6a6')
        .attr('stroke-width','7px')
        .attr('y2','10')
      // create y axis labels
      let datasetSliced=dataset.slice(startSet, endSet);
      let labels=datasetSliced.flatMap(data => data.caption.split(' '));
      svg.select('#g_axis').selectAll('text')
        .data(labels)
        .enter()
        .append('text')
        .attr('x', paddingLeft)
        .attr('y', lineSpacing + dataHeight / 2)
        .text(function (d) {
          return d;
        })
        .attr('transform', function (d, i) {
          if(i===labels.length-1){
            let spaceLabels=10;
            return 'translate(0,' + ((spaceLabels + dataHeight) * i) + ')';
          }
          return 'translate(0,' + ((lineSpacing + dataHeight) * i) + ')';
        })
        .attr('class', 'ytitle');

      // create vertical grid
      svg.select('#g_axis').selectAll('line.vert_grid').data(xScale.ticks())
        .enter()
        .append('line')
        .attr({
          'class': 'vert_grid',
          'x1': function (d) {
            return xScale(d);
          },
          'x2': function (d) {
            return xScale(d);
          },
          'y1': 0,
          'y2': dataHeight * noOfDatasets + lineSpacing * noOfDatasets - 1 + paddingBottom
        });
      if(message.show) {
        setTimeout(() => {
          d3.select('[class*="section_"] svg foreignObject').remove();
          d3.select('[class*="section_"] svg').data([message])
            .append("foreignObject")
            .attr("x", 0)
            .attr("y", 55)
            .attr("class", "node")
            .attr("width", '100%')
            .attr("height", 175)
            .html(function(d) {
              return `<div class="root-view">
                    <div class="message-content">
                            <div class="icon">
                              <i class="gg-info"></i>
                            </div>
                            <div class="body">${d.body.map(e => e).join('')}</div>
                    </div>
                </div>`
            })
        }, 2e2)
      }

      // create horizontal grid

      svg.select('#g_axis').selectAll('line.horz_grid').data(dataset)
        .enter()
        .append('line')
        .attr({
          'class': 'horz_grid',
          'x1': 0,
          'x2': width,
          'y1': function (d, i) {
            return ((lineSpacing + dataHeight) * i) + lineSpacing + dataHeight / 2;
          },
          'y2': function (d, i) {
            return ((lineSpacing + dataHeight) * i) + lineSpacing + dataHeight / 2;
          }
        });

      // create x axis
      svg.select('#g_axis').append('g')
        .attr('class', 'axis')
        .call(xAxis);

      // make y groups for different data series


      console.log("dataset : ",dataset);
      const g = svg.select('#g_data').selectAll('.g_data')
        .data(dataset.slice(startSet, endSet))
        .enter()
        .append('g')
        .attr('transform', function (d, i) {
          return 'translate(0,' + ((lineSpacing + dataHeight) * i) + ')';
        })
        .attr('class', 'dataset');
      // add data series
      const rect = g.selectAll('rect')
        .data(function (d) {
          return d.disp_data;
        })
        .enter()
        .append('rect')
        .attr('tets', (d) => {
          let e = optionData.temps_data.filter(e => e.start == moment(d[0]).format('YYYY-MM-DD HH:mm:ss') && e.end == moment(d[2]).format('YYYY-MM-DD HH:mm:ss'))
          return e.id
        })
        .attr('username', optionData.user.username)
        .attr('x', function (d) {
          // patch
          optionData.event && optionData.event.patch && optionData.event.patch.bind(this)(d, {xScale, tooltip: div, parseDate});
          return xScale(d[0]);
        })
        .attr('y', lineSpacing)
        .attr('width', function (d) {
          return (xScale(d[2]) - xScale(d[0]));
        })
        .attr('height', dataHeight)
        // .attr('fill', 'fill: url(\'#grad1\') !important;')
        .attr('class', function (d) {
          const n = optionData.legend && typeof optionData.legend[d[1]] != 'undefined' ? optionData.legend[d[1]] : {class: d[1], label: d[1]};;
          if (n === undefined) { console.error('>>> Not Found ', d[1]); }
          if (d && d.length>5){
            const n2 = optionData.legend && typeof optionData.legend[d[5]] != 'undefined' ? optionData.legend[d[5]] : {class: d[5], label: d[5]};
            if (n && n2)
              return n.class +" " +n2.class;
          }
          return d.__data__ && d.__data__.motif && d.__data__.motif.code == "FORMATIONALTERNANCE" ? 'FORMATION_ALTERNANCE_INSERVICE' : n.class;
        })
        .on('mouseover', function (d, i) {
          let label = '';
          const elementRect = this.getBoundingClientRect();
          const matrix = this.getScreenCTM().translate(+this.getAttribute('x'), +this.getAttribute('y'));

          if(optionData.view == 'ONLY_DATA') {
            tooltipResize.transition()
              .duration(200)
              .style('opacity', 1);


            const id = d[6];
            const block = document.querySelector('app-mutualisation-dialog .block-item.block-item-' + id);

            if(block && !block.classList.contains('block-item-active')) {
              block.classList.add('block-item-active')
              block.scrollIntoView({ block: 'end',  behavior: 'smooth' });
            }

            /*            tooltipResize.html(function () {

                          return `<div style="display: flex;flex-direction: row;flex: 1;height: 100%;min-height: 30px;align-items: center;">
                                <div>
                                  <i class="material-icons">percent</i>
                                </div>
                                <div>
                                  <i class="material-icons">percent</i>
                                </div>
                                <div>
                                  <i class="material-icons">percent</i>
                                </div>
                              </div>`
                        })
                          .style('left', function () {
                          return ((window.pageXOffset + matrix.e + elementRect.width) - 100) + 'px';
                        })
                          .style('top', function () {
                            return ((window.pageYOffset + matrix.f) - 31) + 'px';
                          })*/;

            return;
          };
          const id = this.getAttribute('username');

          div.transition()
            .duration(200)
            .style('opacity', 1);
          div.html(function () {
            let output = '';
            let DureeBreak = null;
            let exceptionalTypeLabel = null;
            let motif = '';
            let justif = '';
            let Tmotif = '';
            originData[id].data.forEach((t, i) => {
              const same = typeof t.GMT === 'undefined' ?
                moment(t.start, 'YYYY-MM-DD HH:mm:ss')
                  .isSame(moment(d[0], 'YYYY-MM-DD HH:mm:ss')) :
                moment(t.start, 'YYYY-MM-DD HH:mm:ss')
                  .isSame(moment( d[0] , 'YYYY-MM-DD HH:mm:ss'));

              if (t.tag === 'Fulfilled_system') {
                if (moment(t.start, 'YYYY-MM-DD HH:mm:ss').isSame(moment(d[0], 'YYYY-MM-DD HH:mm:ss')) &&
                  t.legend === d[1]
                ) {
                  DureeBreak = t.durationBreak + ' min';
                }
              }
              if (t.tag.toLowerCase() === 'incoherence') {
                if ( same && t.legend === d[1]) {
                  if (t.motif && t.motif.code && ("CONTROLEQUALITE".includes(t.motif.code.toUpperCase()) || "FORMATIONCONTINUE".includes(t.motif.code.toUpperCase())))
                    motif =  (t.motif.label === '' ?  '' : translate.MOTIFS[t.motif.code]);
                  else
                    motif =  (t.motif.label === '' ?  '' : ' : ' +  translate.MOTIFS[t.motif.code]);
                  label =  (t.motif.label === '' ?  'INSERVICE' : label);
                  //justif = JustificationMapper[t.justification] ? JustificationMapper[t.justification] : t.justification ;
                  justif = t.justificationLibelle ? t.justificationLibelle : t.justification;
                  motifGlobalCode = Tmotif = t.motif.code;
                }
              }
              if (same && t.legend === d[1]) {
                exceptionalTypeLabel = t.exceptionalTypeLabel
              }
            });

            if (['UNKNOWN', 'EMPTY'].indexOf(d[1]) === -1) {
              label = (label == 'INSERVICE' ? label :  optionData.legend[d[1]].label);
              const klass = optionData.legend[d[1]].class;
              let direction: any = '';
              if (parseInt(elementRect.x) > (window.innerWidth - 300)) {
                direction = 'style="right: -' + parseInt(elementRect.width) + 'px"';
              } else {
                direction = '';
              }
              const o = {direction: direction, klass: klass, justif: justif, DureeBreak, motif: motif, label: label, exceptionalTypeLabel};
              output = tooltip(o, d, config,countryCode);
            }
//             // console.log(output)
            return output;
          })
            .style('left', function () {
              return window.pageXOffset + matrix.e + 'px';
            })
            .style('top', function () {
              return window.pageYOffset + matrix.f - 11 + 'px';
            })
            .style('height', dataHeight + 11 + 'px');
        })
        .on('mouseout', function () {
          div.transition()
            .duration(500)
            .style('opacity', 0);
          const blocks: any = document.querySelectorAll('app-mutualisation-dialog .block-item');
          blocks.forEach((b) => {
            b.classList.remove('block-item-active')
          })

        })
        .on('click', openDialogJustifyIncoBreaks)
        .call(resize);




      dataBreaks = [];
      let _w = 0;
      /*if (rect.length > 0) {
         const d: Array<any> = rect[0];
         d.forEach((r, i) => {
           if (r.getAttribute('class') === 'PAUSE_INSERVICE')
             dataBreaks.push(r);
         })


         dataBreaks.forEach((x, i) => {
           const e = x.cloneNode(true);
           e.setAttribute('x', _w)
           e.setAttribute('y', '-10')
           _w += parseInt(e.getAttribute('width'))
           svg.select('#graph_' + optionData.user.username + ' #g_breaks').node().appendChild(e);
         })
       }*/

      // #rf_code
      if (originData &&  originData[optionData.user.username] && originData[optionData.user.username].breaks && originData[optionData.user.username].breaks.length > 0 && thiscomponent.actions) {
        const r = originData[optionData.user.username].breaks;
        r.forEach((d, i) => {
          addRectBreak(_w, {id: d.id, motif: d.motif && d.motif.code, time: d.duration});
          _w += 50;
        })
        let notClickBreak = (thiscomponent.conditionValidationButton.isValidateFULFILLED_INCOHERENCE)
        let div = d3.select('body').append('div')
          .attr('class', 'tooltip')
          .style('opacity', 0);
        d3.select(selector + ' #graph_' + optionData.user.username + ' #g_breaks').selectAll('rect')
          .on('click', function (d, i) {
            if(thiscomponent._isNow || notClickBreak){
              console.log('isNow or is not bolck Clickable');
              return;
            }
            localStorage.setItem('divBlock', '0')
            localStorage.setItem('usernameEdit', this.getAttribute('username'))

//            console.log(thiscomponent.conditionValidationButton.isUpdateBreaks)
            //if (!thiscomponent.conditionValidationButton.isValidateBreaks) {
            const id = this.getAttribute('username');
            const temps = [];
            let unlocked = false;
            /*// console.warn('Data >>> ', optionData.temps_data)*/
            originData[id].data.forEach((e, k) => {
              if(e.motif) {
                if (['FULFILLED_INCOHERENCE'].indexOf(e.name) > -1 && e.activityType.toLowerCase() !== 'unknown'
                  && ['SEUILMOINS', 'SEUILPLUS'].indexOf(e.motif.code) === -1 && e.validatedBy == null) {
                  if (e.GMT === undefined) {
                    e.start = e.start;
                    e.end = e.end;
                    e.GMT = thiscomponent.blockservice.tzService.tz;
                  }
                  if(temps.map(e => e.id).indexOf(e.id) == -1) {
                    temps.push(e);
                  }
                  if (e.locked.toLowerCase() === 'unlocked') {
                    unlocked = true;
                  }
                }
              }
            });
            // add overflows breaks
            if ( originData[id].breaks.length > 0) {
              originData[id].breaks.forEach((r, i) => {
                if ( temps.map(x => x.id).indexOf(r.id) == -1 &&
                  r.break.user.username == id
                ) {
                  let breakOverflow = {
                    id: r.id,
                    pause: r.break,
                    duration: r.duration,
                    motif: r.motif,
                  };
                  temps.push(r)
                }
              });
            }
            component.closeAll();
            if (thiscomponent.isCurrentUser() && optionData.Display.dialog && temps.length > 0 && !thiscomponent._enableVerro) {
              component.open(_dialog, {
                panelClass: 'app-dialog',
                data: {
                  that: component,
                  temps: temps,
                  isFormation: thiscomponent._isFormation,
                  user: optionData.user
                }
              });
            }
            // }
          })

          .on('mouseover', function(d) {
            const p = this.getBoundingClientRect();
            const o = {direction: '', klass: 'break_off', justif: '',
              DureeBreak: thiscomponent.BreakDuration(this.getAttribute('time')),
              motif: '', label: this.getAttribute('motif')};
            div.transition()
              .duration(200)
              .style("opacity", 1);
            div	.html(tooltip(o, null, config,countryCode))
              .style("left", (p.left - 1) + "px")
              .style("top", (p.top - p.height + 6) + "px");
          })
          .on("mouseout", function(d) {
            div.transition()
              .duration(500)
              .style("opacity", 0);
          });
      }


      function addRectBreak(_w, d) {
        if (optionData.Display.breaks) {
          if (d.time > environment.breaks.DURATION.value) {
            svg.select('#g_breaks')
              .append('rect')
              .attr('blockId', d.id)
              .attr('username', optionData.user.username)
              .attr('x', _w)
              .attr('data-test-id', 'break-over')
              .attr('y', '-10')
              .attr('width', '50')
              .attr('height', dataHeight)
              .attr('class', 'break_off')
              .attr('motif', d.motif)
              .attr('time', d.time)
          }
        }
      }

      /*const date   =  moment(thiscomponent.valueDate)
      const period = thiscomponent._period;
      const isNext =  (period.start == null ? true : date.isSameOrAfter(moment(period.start)))
      const isPrev =  (period.end == null ? true : date.isSameOrBefore(moment(period.end)))
      const startValue = (period.start== null ? moment(date).format('YYYY-MM-DD') :  period.start)
      const endValue = (period.end == null ? moment().format('YYYY-MM-DD') :  period.end)
      thiscomponent.actions = true;
      if (!isNext || !isPrev) {
        thiscomponent.actions = false;
        svg.select('#g_data')
             .append('foreignObject')
             .attr("id", "Expired")
             .attr("x", "-1")
             .attr("y", "0")
             .attr("width", "100%")
             .attr("style", "background:#fff")
             .attr("height", "100")
           d3.select('#Expired').html(`
         <div class="not_sheet">
             <i class="material-icons">warning</i>
             <b>Le shift de l'agent est actif entre: [${startValue} <=> ${endValue}]</b>
             <button date="${startValue}">Aller a cette période</button>
         </div>
        `)
        d3.select('.not_sheet button').on('click', function() {
          thiscomponent.toDate(this.getAttribute('date'));
        })
       }*/

      // onmouse over
      function tooltip(obj, d, config,countryCode) {
        //console.log("obj ",obj)
        let commentHtml = "";
        let blockLabel = translate.LEGENDS[obj.label] !== '' ? translate.LEGENDS[obj.label] + obj.motif : '';
        let blockClass = obj.motif.toLowerCase().includes("f.alternance") ?'FORMATION_ALTERNANCE_INSERVICE':obj.klass
        let dateShift = countryCode === 'EG' && d && d.__data__ && d.__data__.dateShift ? "Date : "+ moment(d.__data__.dateShift).format(DATE_D_M_Y_SLASH_FORMAT):"";
        if (d && d.__data__ && d.__data__.motif && ['SEUILPLUS','SEUILMOINS'].includes(d.__data__.motif.code))
        {
          let start = d[0];
          let end = d[2];
          if (start && end && moment(end).diff(start, 'second') <= MIN_BLOCK_LENGTH_FR && countryCode == "FR")
          {
            if (["FORMATIONCONTINUE","CONTROLEQUALITE"].includes(d.__data__.activityType)){
              if(["CONTROLEQUALITE"].includes(d.__data__.activityType))
              {
                blockLabel = translate.LEGENDS['FULFILLED_VALIDATED_CONTROLEQUALITE'];
                blockClass = "FULFILLED_VALIDATED_CONTROLEQUALITE";
              }

              if(["FORMATIONCONTINUE"].includes(d.__data__.activityType)){
                blockClass = "FULFILLED_VALIDATED_FORMATIONCONTINUE";
                blockLabel = translate.LEGENDS['FULFILLED_VALIDATED_FORMATIONCONTINUE'];
              }
            }else
              blockLabel = translate.LEGENDS["FULFILLED_VALIDATED_INSERVICE"];

          }}

        if (d && d.__data__ && d.__data__.comments &&  d.__data__.comments.length > 0)
        {
          if (d.__data__.comments.filter(c=> c.type === "INCOHERENCE").length > 0){
            let dataComment = d.__data__.comments[0];
            let date = moment(thiscomponent.blockservice.tzService.GmtToLocale(dataComment.creationDate)).format('DD/MM/YYYY  HH:mm');
            commentHtml = '<div  class="' + blockClass + ' comment-tooltip">Commentaire</div>'+
              '<div style="padding: 5px 5px;">' +
              '<span >'+'Ajouté par '+'</span>' +
              '<span class="name-comment">'+dataComment.addedBy.fullName+ ' ['+dataComment.addedBy.username+'] '+'</span>' +
              '<span >'+' le '+'</span>' +
              '<span class="name-comment">'+ date +'</span>' +
              '<div style="margin-top: 12px;">' +
              '<div style="background: #eee; padding: 3%;" readonly  mat-autosize="1000"> ' +dataComment.text+' </div>'+
              '</div>' +
              '</div>';
          }
          else{
            d.__data__.comments.forEach((dataComment,index)=> {
              let date = moment(thiscomponent.blockservice.tzService.GmtToLocale(dataComment.creationDate)).format('DD/MM/YYYY  HH:mm');
              if (index === 0) commentHtml =  '<div  class="' + blockClass + ' comment-tooltip">Commentaire</div>';
              commentHtml = commentHtml + '<div style="padding: 5px 5px;">' +
                '<span >'+'Ajouté par '+'</span>' +
                '<span class="name-comment">'+dataComment.addedBy.fullName+ ' ['+dataComment.addedBy.username+'] '+'</span>' +
                '<span >'+' le '+'</span>' +
                '<span class="name-comment">'+ date +'</span>' +
                '<div style="margin-top: 12px;">' +
                '<div style="background: #eee; padding: 3%;" readonly  mat-autosize="1000"> ' +dataComment.text+' </div>'+
                '</div>' +
                '</div>';
            })
          }
        }
        if (obj.label && ["CONTROLE_QUALITE_INSERVICE","INCOHERENCE_VALIDATED_CONTROLEQUALITE","INCOHERENCE_VALIDATED_CONTROLEQUALITE_BYUSER",
          "FULFILLED_VALIDATED_CONTROLEQUALITE_BYUSER","INCOHERENCE_VALIDATED_FORMATIONCONTINUE_BYUSER","INCOHERENCE_VALIDATED_FORMATIONCONTINUE"].includes(obj.label))
          blockLabel = obj.motif
        if(obj.klass==='break_off'){
          blockLabel=translate.MOTIFS[obj.label] !== '' ? translate.MOTIFS[obj.label] + obj.motif : '';
        }
        if( obj.justif !== '' && obj.justif !== undefined
          && (obj.justif === 'DEL' || obj.justif === 'TRA' || obj.justif === 'DED'
            || obj.justif === 'AAP' || obj.justif === 'CTM' || obj.justif === 'VME'
            || obj.justif === 'ADM' || obj.justif === 'GRE' || obj.justif === 'CSE'
            || obj.justif === 'ELU' || obj.justif === 'AST' || obj.justif === 'ARH'
            || obj.justif === 'ANR' || obj.justif === 'ATC' || obj.justif === 'ATR'
            || obj.justif === '111' || obj.justif === 'PNF' || obj.justif === 'PNO'
            || obj.justif === 'MLC' || obj.justif === 'MAP' || obj.justif === 'MOB'
            || obj.justif === 'VLM' || obj.justif === 'HAL' || obj.justif === 'CMM'
            || obj.justif === 'NHC' || obj.justif === 'SCT' || obj.justif === 'ALT'
            || obj.justif === 'FIR' || obj.justif === 'MON' || obj.justif === 'PNP'
            || obj.justif === 'PNE' || obj.justif === 'REF' || obj.justif === 'RAN'
            || obj.justif === 'RDI' || obj.justif === 'RHA' || obj.justif === 'RNE'
            || obj.justif === 'MI1'|| obj.justif === 'Délégation TAD'
          )) {
          blockLabel = translate.LEGENDS[obj.label] !== '' ? translate.LEGENDS[obj.label] : '';
          obj.justif = translate.JUSTIFS[obj.justif];
        }
        if(obj.exceptionalTypeLabel) {
          blockLabel = obj.exceptionalTypeLabel
        }
        if (d && d.__data__ && d.__data__.justification && ["MOD", "NOA"].includes(d.__data__.justification))
          blockLabel = STATUS_MOTIF_MOD;
        return '<div class="block-info" ' + obj.direction + '>' +
          '<table> ' +
          '<thead class="' + blockClass + '">' +
          '<tr>' +
          '<th>' + translate.BLOCK_TEMPS.TOOLTIP.STATUS + '</th>' +
          (obj.justif !== '' && obj.justif !== undefined ? '<th>' + translate.BLOCK_TEMPS.TOOLTIP.JUSTIFICATION + '</th>' : '') +
          (d !== null ?'<th>'+translate.BLOCK_TEMPS.TOOLTIP.FROM+'</th>' +
            '<th>' +translate.BLOCK_TEMPS.TOOLTIP.TO+ '</th> ': '') +
          '<th style="display: ' + (obj.DureeBreak !== null ? 'table-cell' : 'none') + ';">'+translate.PAUSE+'</th>' +
          '<th>GMT</th> ' +
          '</tr>' +
          '</thead>' +
          '<tr> ' +
          '<td>' + blockLabel + '</td>' +
          (obj.justif !== '' && obj.justif !== undefined ? '<td>' + obj.justif + '</td>' : '') +
          (d !== null ?
            '<td>' + moment(parseDate(d[0])).format(config.extras.BLOCK_DATE_FORMAT) + '</td>' +
            '<td>' + moment(parseDate(d[2])).format(config.extras.BLOCK_DATE_FORMAT) + '</td>' : '' ) +
          '<td style="display: ' + (obj.DureeBreak !== null ? 'table-cell' : 'none') + ';">' + obj.DureeBreak + '</td> ' +

          '<td class="gmt-width"> ' + (TimezoneGMT === 0 ? '' : (TimezoneGMT < 0 ? '- ' : '+ ')) +  Math.abs(TimezoneGMT) +'<div style="font-size: 53%">'+dateShift+'</div>'+ ' </td>' +
          '</tr>' +
          (d !== null && d[4] !== undefined && d[4] !== 'SYSTEM' ? '<tr><td>Source</td><td>' + d[4] + '</td></tr>' : '') +
          '</table>' + commentHtml +
          '</div>'}

      function motifSelect(defaultValue, type) {
        type = type.toLowerCase() == "inco(+)" ? "PLUS" : "MINUS";

        return `<select id="selectMotifsplit" style=" border: none; background: #f3f3f3; height: 30px; outline: 0;">${optionData.event.MOTIFS.filter(e => e.type == type).map(m => {
          return `<option value="${m.code}" ${defaultValue.trim() == m.label.trim() ? 'selected' : ''}>${m.label}</option>`
        }).join('')
        }</select>`
      }
      function tooltipSplit(obj: any, d: Array<any>) {
        return '<div class="block-info" ' + obj.direction + '>' +
          '<table> ' +
          '<thead class="' + obj.klass + '">' +
          '<tr>' +
          '<th>Statut</th>' +
          (d !== null ?'<th>De</th>' +
            '<th>à</th> ': '') +
          '<th>Actions</th> ' +
          '</tr>' +
          '</thead>' +
          '<tr> ' +
          '<td>' + (motifSelect(obj.motif.replace(":", "").trim(), obj.label))  + '</td>' +
          (d !== null ?
            '<td>' + moment(parseDate(d[0])).format('DD/MM HH:mm') + '</td>' +
            '<td>' + moment(parseDate(d[2])).format('DD/MM HH:mm') + '</td>' : '' ) +
          '<td>' +
          '<button id="save">+</button>' +
          '<button id="cancel">x</button>' +
          ' </td>' +
          '</tr>' +
          '</table></div>';
      }
      // rework ticks and grid for better visual structure
      function isYear(t) {
        return +t === +(new Date(t.getFullYear(), 0, 1, 0, 0, 0));
      }

      function isMonth(t) {
        return +t === +(new Date(t.getFullYear(), t.getMonth(), 1, 0, 0, 0));
      }

      const xTicks = xScale.ticks();
      const isYearTick = xTicks.map(isYear);
      const isMonthTick = xTicks.map(isMonth);
      // year emphasis
      // ensure year emphasis is only active if years are the biggest clustering unit
      if (emphasizeYearTicks
        && !(isYearTick.every(function (d) {
          return d === true;
        }))
        && isMonthTick.every(function (d) {
          return d === true;
        })) {
        d3.selectAll('g.tick').each(function (d, i) {
          if (isYearTick[i]) {
            d3.select(this)
              .attr({'class': 'x_tick_emph'});
          }
        });
        d3.selectAll('.vert_grid').each(function (d, i) {
          if (isYearTick[i]) {
            d3.select(this)
              .attr({'class': 'vert_grid_emph'});
          }
        });
      }

      // create title
      if (drawTitle) {
        svg.select('#g_title')
          .append('text')
          .attr('x', paddingLeft + 50)
          .attr('y', paddingTopHeading - 5)
          .text(optionData.user.firstname + ' ' + optionData.user.lastname)
          .attr('class', 'heading');

      }
      if (optionData.Display.breaks) {
        const translateBreakOverflow = translate.BLOCK_TEMPS.BREAK_OVERFLOW.split(' ');
        const [breakLabel, overLabel] = translateBreakOverflow;
        // add breaks
        svg.select(selector + ' #graph_' + optionData.user.username + ' #g_breaks')
          .append('text')
          .attr('x', '-100')
          .attr('y', '-5')
          .text(breakLabel)
          .attr('class', 'ytitle');

        svg.select(selector + ' #graph_' + optionData.user.username + ' #g_breaks')
          .append('text')
          .attr('x', '-100')
          .attr('y', '15')
          .text(translateBreakOverflow.length > 2?overLabel +' '+ translateBreakOverflow[2] :overLabel)
          .attr('class', 'ytitle');

        svg.select(selector + ' #graph_' + optionData.user.username + ' #g_breaks')
          .append('text')
          .attr('x', '300')
          .attr('y', '0')
          .attr('class', 'ytitle');
      }
      svg.select('#g_title')
        .append('text')
        .attr('x', paddingLeft + 100)
        .attr('y', paddingTopHeading + 17)
        .attr('username', optionData.user.username)
        .text(((s) => {
          s = String(s);
          return s[0].toUpperCase() + s.slice(1);
        })(moment(parseDate((originData[optionData.user.username] ? originData[optionData.user.username] : optionData.user).date)).locale(lang).format('dddd DD MMMM Y'))) // #rf_code
        .attr('class', 'subheading')
        .attr('data-test-id', 'date-value')
        .attr('x', 5)
        .on('click', function (d, i) {
          if (optionData.Display.paginator) {
            const date = (originData[optionData.user.username] ? originData[optionData.user.username] : optionData.user).date; // rf_code
            picker.panelClass = 'calendar-block'
            picker.open();
          }
        });
      // create subtitle
      if (optionData.Display.paginator) {
        const d1 = moment(thiscomponent.valueDate, 'YYYY-MM-DD').add(Action['now'], 'days').format('YYYY-MM-DD');
        const l2 = moment(thiscomponent.minDate, 'YYYY-MM-DD').format('YYYY-MM-DD');

        if (moment(d1).isAfter(l2) && !moment(d1).isSame(l2)) {
          /*Arrow left*/
          svg.select('#g_title')
            .append('image')
            .attr('xlink:href', 'assets/icons/left.ico')
            .attr('id', 'left-arrow')
            .attr('data-test-id', 'date-prev')
            .attr('style', 'fill: white !important;')
            .attr('width', 20)
            .attr('height', 20)
            .attr('x', -35)
            .attr('y', -48)
            .attr('username', optionData.user.username)
            .on('click', function (d, i) {
              if(!thiscomponent.blockNavigation){
                const username = this.getAttribute('username');
                current_date = new Date(originData[username].date)
                thiscomponent.GoToDate('prevDay', username);
              }
            });
        }

        const d2 = moment(thiscomponent.maxDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
        if (moment(d1).isBefore(d2) && !moment(d1).isSame(d2)) {
          /*Arrow right*/
          svg.select('#g_title')
            .append('image')
            .attr('xlink:href', 'assets/icons/right.ico')
            .attr('id', 'right-arrow')
            .attr('data-test-id', 'date-next')
            .attr('style', 'fill: white !important;')
            .attr('width', 20)
            .attr('height', 20)
            .attr('x', 170)
            .attr('y', -48)
            .attr('username', optionData.user.username)
            .on('click', function (d, i) {
              if(!thiscomponent.blockNavigation){
                const username = this.getAttribute('username');
                current_date = new Date(originData[username].date)
                thiscomponent.GoToDate('nextDay', username);
              }
            });
        }

        /* Refresh button */
        // svg.select('#g_title')
        //   .append('image')
        //   .attr('xlink:href', 'assets/icons/refresh.ico')
        //   .attr('id', 'refresh')
        //   .attr('style', 'fill: white !important;')
        //   .attr('width', 20)
        //   .attr('height', 20)
        //   .attr('x', 130 )
        //   .attr('y', -48)
        //   .attr('username', optionData.user.username)
        //   .on('click', function (d, i) {
        //     const username = this.getAttribute('username');
        //     current_date = new Date(originData[username].date)
        //     thiscomponent.GoToDate('refresh', username);
        //   })
        //   .on('mouseover', function (d, i) {
        //     console.log('enter mouseover function');
        //     var refreshButton =  document.getElementById('refresh');
        //      refreshButton.setAttribute('title', 'Refresh');
        //      refreshButton.focus();
        //       // console.log(3, this.getAttribute('id'), document.getElementById('refresh'));
        //   });
      }

      // if (debug.block && optionData.Display.paginator) {
      //   /* open link button */
      //   svg.select('#g_title')
      //     .append('image')
      //     .attr('xlink:href', 'assets/icons/link.ico')
      //     .attr('id', 'lien')
      //     .attr('style', 'fill: white !important;')
      //     .attr('width', 20)
      //     .attr('height', 20)
      //     .attr('x', 180 )
      //     .attr('y', -48)
      //     .attr('username', optionData.user.username)
      //     .on('click', function (d, i) {
      //       const username = this.getAttribute('username');
      //       thiscomponent.emit.DetailsEventEvent({optionData})
      //       //            window.open(environment.api.blocktemps + '?username=' + username + '&date=' + optionData.user.date );
      //     });
      // }


      // create legend
      const legend = svg.select('#g_title')
        .append('g')
        .attr('id', 'g_legend')
        .attr('transform', 'translate(-180,-20)');
      let p = 0;
      let calcTitle = 0;
      let last = '';
      if(DataLegend.includes(PAUSE_INSERVICE) && DataLegend.includes(FULLFILLED_PAUSE)){
        DataLegend = DataLegend.filter(legend => legend != FULLFILLED_PAUSE);
      }

      if(DataLegend.filter(d=> d.label.includes(PAUSE_INSERVICE)).length>0 && DataLegend.filter(d=> d.label.includes(FULLFILLED_PAUSE)).length>0){
        DataLegend = DataLegend.filter(legend => legend.label != FULLFILLED_PAUSE);
      }
      DataLegend = Array.from(new Map((DataLegend as any).map((item: any) => [item["label"], item])).values());

      DataLegend.forEach(function(o, i) {
        const {label, exceptionalTypeLabel} = o;
        let n : any = label;
        n = optionData.legend  && optionData.legend[n] ? optionData.legend[n] : {class: n, label: n}; // #rf_code
        if ( n.display ) {
          let o = 0;
          p++;
          var pp = (p * 80 );
          o = calcTitle + (p==1?80:20); //(calcTitle >= pp  ? (pp + 65) : pp)
          legend.append('rect')
            .attr('x', o)
            .attr('y', paddingTopHeading)
            .attr('height', 12)
            .attr('width', 12)
            .attr('ry', 100)
            .attr('rx', 100)
            .attr('class', n.class);
          const label=n.label;
          var [title] = legend.append('text')
            .attr('x', o + 20  )
            .attr('y', paddingTopHeading + 10.4 )
            .text(exceptionalTypeLabel || translate.LEGENDS[label])
            .attr('class', 'legend_title');
          var t = title[0];
          var bbox = t.getBBox();
          calcTitle = bbox.x + bbox.width
        }
        if (i == DataLegend.length - 1 && allTadHours.length>0){
          let o = 0;
          p++;
          var ppp = (p * 80 );
          legend.append('rect')
            .attr('x', o = (calcTitle >= ppp  ? (ppp + 65) : ppp))
            .attr('y', paddingTopHeading)
            .attr('height', 12)
            .attr('width', 0)
            .attr('ry', 100)
            .attr('rx', 100)
            .attr('class', "");
          var [title1] = legend.append('text')
            .attr('x', o + 20  )
            .attr('y', paddingTopHeading + 10.4 )
            .text("// TAD")
            .attr('class', 'legend_title tad-legend');
          var tt = title1[0];
          var bboxx = tt.getBBox();
          calcTitle = bboxx.x + bboxx.width
        }
      });

    });
    return chart;
  }
  (chart as any).load = function (_: any): any {
    _ && _(originData[optionData.user.username]);
    return chart;
  };

  (chart as any).dialog = function (_: any, events?: any): any {
    if (!arguments.length) { return _dialog; }
    _dialog = _;
    return chart;
  };
  (chart as any).callback = function (_: any): any {
    if (!arguments.length) { return component; }
    component = _;
    return chart;
  };

  (chart as any).width = function (_: any): any {
    if (!arguments.length) { return width; }
    //width = _;
    return chart;
  };

  (chart as any).drawTitle = function (_: any): any {
    if (!arguments.length) { return drawTitle; }
    drawTitle = _;
    return chart;
  };

  (chart as any).maxDisplayDatasets = function (_: any): any {
    if (!arguments.length) { return maxDisplayDatasets; }
    maxDisplayDatasets = _;
    return chart;
  };

  (chart as any).curDisplayFirstDataset = function (_: any): any {
    if (!arguments.length) { return curDisplayFirstDataset; }
    curDisplayFirstDataset = _;
    return chart;
  };

  (chart as any).emphasizeYearTicks = function (_: any): any {
    if (!arguments.length) { return emphasizeYearTicks; }
    emphasizeYearTicks = _;
    return chart;
  };

  (chart as any).isShowMessage = function (_: any): any {
    return message.show;
  };

  (chart as any).showDialogIcons = function (d: any): any {
    if(d) openDialogJustifyIncoBreaks(d);
  };


  return chart;
}
export function cancelSplit(thiscomponent, username) {
  thiscomponent.GoToDate('refresh', username);
}

export function saveNewSplit(thiscomponent: BlockTempsComponent, blockUpdated: any) {
  const formatDate = (e) => thiscomponent.blockservice.tzService.LocaleToGmt(e)
  const blocks = blockUpdated.data.blocks.map((e, i) => {
    const motif = i == 0 ? blockUpdated.block.newMotif || blockUpdated.block.motif : blockUpdated.block.motif;
    return {
      'start': formatDate(e[0]),
      'end': formatDate(e[1]),
      'id': blockUpdated.block.id,
      'motif': {
        "code": motif.code,
        "type": motif.type
      },
      'type': 'INCOHERENCE',
      'updated': true,
      'tag': 'new'
    };
  });
  thiscomponent.blockservice.checkLockedShift({username: blockUpdated.userName}).subscribe((details: any) => {
    thiscomponent.blockservice.putBlock(blocks, () => {
      d3.select('body .tooltip-split').remove();
      thiscomponent.GoToDate('refresh', blockUpdated.userName);
    });
  });
  console.log('VALIDATED NEW DATE', blocks);
}



// WEBPACK FOOTER //
// ./src/app/vendors/visavail/visavial.ts